import { getApiKey } from '@shared/api/get-api-key';

export const isAuthenticated = (): boolean => !!getApiKey();
